export default __webpack_public_path__ + "static/5-b83cbfc871424960e0d2151577e99ee2.jpeg";